import { Injectable } from '@angular/core';
import { AbstractEntityStore } from '@pf/shared-services';
import { PFWmsEntities } from '@pf/shared-common';
import { InventoryBundleRead } from '../../entities/inventory-bundle.dto';

@Injectable()
export class InventoryBundleStore extends AbstractEntityStore<InventoryBundleRead> {
    constructor() {
        super(PFWmsEntities.InventoryBundle);
    }
}
